export default "__VITE_ASSET__CuC2i5uM__"